import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ccc"} }, null, -1)
const _hoisted_3 = { class: "flex flex-row flex-wrap gap-2 max-h-56 overflow-auto" }
const _hoisted_4 = { class: "px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex items-center align-center w-max ease" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-row gap-2 items-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 1 }




export default /*#__PURE__*/_defineComponent({
  __name: 'inputChipSimpler',
  props: {
    array: null,
    ignoreKeys: null,
    labelValue: null,
    keyValue: null
  },
  emits: ["add", "drop"],
  setup(__props: any, { emit }) {

const props = __props as {
  array: Array;
  ignoreKeys?: Array;
  labelValue?: string;
  keyValue?: string;
};





function removeItem(itemIndex: number, item: object) {
  if (props.keyValue) {
    emit("drop", item);
  } else {
    emit("drop", itemIndex);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.array, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "chip",
            key: index
          }, [
            _createElementVNode("span", _hoisted_4, [
              (typeof item == 'object')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (__props.ignoreKeys?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(item), (key) => {
                            return (_openBlock(), _createElementBlock("div", { key: key }, _toDisplayString(__props.ignoreKeys && __props.ignoreKeys.includes(key) ? "" : item[key]), 1))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.labelValue ? item[__props.labelValue] : item), 1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item), 1)),
              _createVNode(_component_mdicon, {
                class: "cursor-pointer",
                name: "close",
                size: "21",
                onClick: ($event: any) => (removeItem(Number(index), item))
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})